const stripTrailingSlash = (value) => value.replace(/\/+$/, "");

const isCapacitorRuntime = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const protocol = window.location?.protocol;
  const hostname = window.location?.hostname;
  return (
    protocol === "capacitor:" ||
    protocol === "ionic:" ||
    (protocol === "https:" && hostname === "localhost") ||
    !!window.Capacitor?.isNativePlatform?.()
  );
};

const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    const normalized = stripTrailingSlash(envUrl);
    return normalized.endsWith("/api") ? normalized.slice(0, -4) : normalized;
  }

  if (isCapacitorRuntime()) {
    return "https://www.shonanpartner.com";
  }

  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ) {
    return "http://localhost:8001";
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return "";
};

export const BACKEND_URL = getBackendUrl();
export const API_BASE_URL = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
export const API = API_BASE_URL;
